import { useEffect, useState } from "react";
import QRCode from "qrcode";

/**
 * Zugang zur Sitzung: Adresse, PIN, QR-Code.
 *
 * Steht auf zwei Folien — auf der Warte-Folie, wo er die Hauptsache ist, und auf
 * der Themenwahl, wo er nebenher weiterläuft: Wer während der Diskussion über
 * das Thema dazukommt, soll sich noch anmelden können, ohne dass der Moderator
 * zurückblättern muss.
 */

const WORKSHOP_URL = import.meta.env.VITE_WORKSHOP_URL ?? "https://ki.svo-gremien.de/";
/** Wechselt je Besuchergruppe — kommt aus der Build-/Deploy-Umgebung,
 *  steht bewusst nicht im Quelltext. Ohne Wert bleibt das Feld leer. */
const WORKSHOP_PIN = import.meta.env.VITE_WORKSHOP_PIN ?? "";

export function loginUrl(): string {
  const u = new URL(WORKSHOP_URL);
  if (!u.pathname || u.pathname === "/") u.pathname = "/m/login";
  if (WORKSHOP_PIN) u.searchParams.set("pin", WORKSHOP_PIN);
  return u.toString();
}

export const zugangsAdresse = WORKSHOP_URL.replace(/^https?:\/\//, "").replace(/\/$/, "");
export const zugangsPin = WORKSHOP_PIN;

/** QR-Code als SVG. `groesse` steuert nur die CSS-Klasse, nicht die Auflösung. */
export function QrCode({ klein = false }: { klein?: boolean }) {
  const [svg, setSvg] = useState<string | null>(null);

  useEffect(() => {
    QRCode.toString(loginUrl(), {
      type: "svg",
      errorCorrectionLevel: "H",
      margin: 0,
      color: { dark: "#161B21", light: "#FFFFFF" },
    })
      .then(setSvg)
      .catch(() => setSvg(null));
  }, []);

  return (
    <div className={`ar-qr${klein ? " ar-qr-klein" : ""}`}>
      {svg ? (
        <span
          aria-hidden="true"
          style={{ display: "block", width: "100%", height: "100%" }}
          dangerouslySetInnerHTML={{ __html: svg }}
        />
      ) : (
        <div className="ar-qr-fallback">QR-Code wird erzeugt …</div>
      )}
    </div>
  );
}
